import { TicketOutlinedIcon } from 'helpers/customIcons';
import { Typography } from '@mui/material';
import styled from 'styled-components';

export const CustomizedConfirmationNumberOutlinedIcon = styled(TicketOutlinedIcon)`
  font-size: 54px;
`;
export const Title = styled(Typography)`
  color: #000000;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 120%;

  text-align: center;
`;

export const ApprovedPaymentTitle = styled(Typography)`
  color: #4caf50;
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  text-align: center;
`;
